// Diclamer tooltip: escape sticky/stacking-context clipping by moving blocks to <body>
(function () {
  const diclamers = document.querySelectorAll('.diclamer');
  if (!diclamers.length) return;

  diclamers.forEach(function (el) {
    const block = el.querySelector('.diclamer-block');
    if (!block) return;

    document.body.appendChild(block);
    block.style.position = 'fixed';
    block.style.display = 'none';

    let hideTimer;

    function show() {
      clearTimeout(hideTimer);
      const rect = el.getBoundingClientRect();

      block.style.visibility = 'hidden';
      block.style.top = '-9999px';
      block.style.left = '-9999px';
      block.style.display = 'block';

      const bw = block.offsetWidth;
      const bh = block.offsetHeight;

      let top = rect.top - bh - 8;
      let left = rect.left;

      if (top < 60) top = rect.bottom + 8;
      if (top + bh > window.innerHeight - 10) top = Math.max(10, rect.top - bh - 8);
      if (left + bw > window.innerWidth - 10) left = window.innerWidth - bw - 10;
      if (left < 10) left = 10;

      block.style.top = top + 'px';
      block.style.left = left + 'px';
      block.style.visibility = '';
    }

    function hide() {
      hideTimer = setTimeout(function () { block.style.display = 'none'; }, 100);
    }

    el.addEventListener('mouseenter', show);
    el.addEventListener('mouseleave', hide);
    block.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    block.addEventListener('mouseleave', hide);
  });

  window.addEventListener('scroll', function () {
    document.querySelectorAll('.diclamer-block').forEach(function (block) {
      block.style.display = 'none';
    });
  }, { passive: true });
})();

$(document).ready(function () {
  const table = $('.table_compl');
  if (table.length === 0) {
    return;
  };

  table.find('[comp-table-toggler]').click(function (e) {
    const innerTable = $(this).parents('table'),
      elements = innerTable.find('.hidden');
    e.preventDefault();
    $(this).find('span').toggle();

    if (innerTable.hasClass('showing')) {
      elements.hide(100);
    } else {
      elements.show(100);
    }

    innerTable.toggleClass('showing');
  });
});


const btns = document.querySelectorAll('[data-hide-btn]');

if (btns.length) {
  btns.forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const valueAtr = btn.getAttribute('data-hide-btn');
      const showButton = document.querySelector(`[data-show="${valueAtr}"]`);
      btn.closest(`${valueAtr}`).style.display = 'none';
      showButton.style.display = 'block';
      showButton.scrollIntoView({
        block: 'center',
        behavior: 'smooth',
      });
    });
  })
};

